import { useState } from 'react';
import { Settings as SettingsIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

import FunnelTagEditor from './FunnelTagEditor';

const FunnelSettings = ({ onRefresh }) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant='outline' size='sm' className='gap-2'>
          <SettingsIcon className='h-4 w-4' />
        </Button>
      </DialogTrigger>
      <DialogContent className='w-[80vw] max-w-[1200px]'>
        <DialogHeader>
          <DialogTitle>Funnel Pipeline Chart Settings</DialogTitle>
        </DialogHeader>
        <div className='mt-4 flex-1 overflow-y-auto'>
          <FunnelTagEditor onRefresh={onRefresh} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FunnelSettings;
